import type { ReferenceGenerationErrorReason } from '../domain/errors/ReferenceGenerationError';
import type { ReferenceGeneration } from '../domain/Reference';

export type GenerationStatusLine =
    | { kind: 'running'; firstGeneration: boolean }
    | { kind: 'done'; added: number | null; date: string }
    | { kind: 'failed' }
    | { kind: 'error'; reason: Exclude<ReferenceGenerationErrorReason, 'already_running'> }
    | null;

interface GenerationStatusInput {
    latest: ReferenceGeneration | null;
    requestOngoing: boolean;
    error: ReferenceGenerationErrorReason | null;
    /** The organization already has sections: a generation then only adds the missing ones. */
    hasReference: boolean;
}

/** The one line shown next to the generate button. */
export const buildGenerationStatus = ({
    latest,
    requestOngoing,
    error,
    hasReference,
}: GenerationStatusInput): GenerationStatusLine => {
    if (error && error !== 'already_running') {
        return { kind: 'error', reason: error };
    }
    if (requestOngoing || latest?.status === 'running') {
        return { kind: 'running', firstGeneration: !hasReference };
    }
    if (latest?.status === 'failed') {
        return { kind: 'failed' };
    }
    if (latest?.status === 'done') {
        return { kind: 'done', added: latest.result?.added ?? null, date: latest.finishedAt ?? latest.createdAt };
    }

    return null;
};
